import { render, staticRenderFns } from "./section-program.vue?vue&type=template&id=7f964c63&scoped=true"
import script from "./section-program.vue?vue&type=script&lang=js"
export * from "./section-program.vue?vue&type=script&lang=js"
import style0 from "./section-program.vue?vue&type=style&index=0&id=7f964c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f964c63",
  null
  
)

export default component.exports